import React from 'react';
import cx from 'classnames';
import { twMerge } from 'tailwind-merge';

type PageHeaderTextureVariant = 'yellow' | 'orange' | 'purple';

type Props = {
  textureVariant: PageHeaderTextureVariant;
  className?: string;
};

export const PageHeaderCard: React.FC<Props> = ({ textureVariant, className, children }) => {
  return (
    <div
      className={twMerge(
        cx('flex flex-col items-center gap-24', 'p-32 md:p-40 rounded-lg bg-cover bg-center text-center', {
          'bg-orange-pattern': textureVariant === 'orange',
          'bg-yellow-texture': textureVariant === 'yellow',
          'bg-purple-texture': textureVariant === 'purple',
        }),
        className,
      )}
    >
      {children}
    </div>
  );
};
